import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTotalBusinesses } from 'store/businesses'
import { fetchBusinessReviews, setDisplayedBusiness } from 'store/business'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import styles from './BusinessesList.scss'
import VerticalTable from 'UI/VerticalTable/VerticalTable'
import { businessesColumns } from './utils'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'

interface Business {
  id: string
  businessName: string
  [key: string]: any
}

interface BusinessesListProps {
  isLoadingInitial?: boolean
  isLoadingNextBatch?: boolean
  businesses: Business[]
  onScroll: () => void
  containerRef?: React.RefObject<HTMLElement>
  navigationRef?: React.RefObject<HTMLElement>
  headerRef?: React.RefObject<HTMLElement>
  summaryRef?: React.RefObject<HTMLElement>
}

export default function BusinessesList({
  isLoadingInitial = false,
  isLoadingNextBatch = false,
  businesses,
  onScroll,
  containerRef,
  navigationRef,
  headerRef,
  summaryRef,
}: BusinessesListProps) {
  const dispatch = useDispatch()

  const { trackEvent } = useMatomo()

  const totalBusinesses = useSelector(selectTotalBusinesses)

  return (
    <VerticalTable
      enableColumnPicker
      pageSize={100}
      dataSource={businesses}
      columns={businessesColumns}
      topBarContainerClassName={styles.topBarContainer}
      containerRef={containerRef}
      additionalRefs={[navigationRef, headerRef, summaryRef]}
      fetchNextPage={onScroll}
      total={totalBusinesses}
      tableId='businesses'
      loading={isLoadingNextBatch}
      removeFromPickerColumns={[COLUMNS_IDS.businessName]}
      rowClassName={styles.tableRow}
      onRow={(record: Business) => {
        return {
          onClick: () => {
            dispatch(fetchBusinessReviews({ businessId: record.id }))
            dispatch(setDisplayedBusiness({ business: record }))

            trackEvent({
              category: 'Business Mapper List',
              action: `User clicked on Business ${record.businessName}`,
            })
            window.open(`${window.location.origin}/singleBusiness/${record.id}`, '_blank')
          },
        }
      }}
      diffHeight={50}
    />
  )
}
